export default "__VITE_ASSET__CfXjo1FK__"